import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { withIntegrationApp } from 'src/hocs/withIntegrationApp';
import {
  WizardProvider,
  useWizard,
  CampaignForm,
} from '../components/wizard/WizardContext';
import { CampaignProvider } from '../contexts/CampaignContext';
import BuildYourOutreachFlow from './BuildYourOutreachFlow';
import ConfigureSettings from './ConfigureSettings';
import AddContacts from './AddContacts';

const WizardSteps = () => {
  const { currentStep } = useWizard();

  if (currentStep === 2) return <ConfigureSettings />;
  if (currentStep === 3) return <AddContacts />;
  return <BuildYourOutreachFlow />;
};

type CampaignInit = {
  name?: string;
  description?: string;
  referenceId?: string;
  contactWindowId?: string;
};

const CampaignWizardLayout = () => {
  const location = useLocation();
  const state =
    (location.state as { campaignInit?: CampaignInit } | null) || null;
  const campaignInit = state?.campaignInit;

  return (
    <CampaignProvider>
      <WizardProvider>
        <Initializer init={campaignInit} />
        <WizardSteps />
      </WizardProvider>
    </CampaignProvider>
  );
};

const Initializer = ({ init }: { init?: CampaignInit }) => {
  const { setCampaignAutomation, campaignAutomation } = useWizard();
  useEffect(() => {
    if (!init) return;
    const next: CampaignForm = {
      ...campaignAutomation,
      name: init.name ?? campaignAutomation.name,
      description: init.description ?? campaignAutomation.description,
      referenceId: init.referenceId ?? campaignAutomation.referenceId,
    };
    next.contactWindowId =
      init.contactWindowId ?? campaignAutomation.contactWindowId;
    if (
      next.name !== campaignAutomation.name ||
      next.description !== campaignAutomation.description ||
      next.referenceId !== campaignAutomation.referenceId
    ) {
      setCampaignAutomation(next);
    }
  }, [init, setCampaignAutomation, campaignAutomation]);
  return null;
};

export default withIntegrationApp(CampaignWizardLayout);
